// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__vg10Z","savePackageButton":"ClientWallet_savePackageButton__2AIzx"};